import { render } from "./Saldo.vue?vue&type=template&id=65d81e95&scoped=true"
import script from "./Saldo.vue?vue&type=script&lang=js"
export * from "./Saldo.vue?vue&type=script&lang=js"

import "./Saldo.vue?vue&type=style&index=0&id=65d81e95&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d81e95"]])

export default __exports__